import Header from './components/Header';
import HeroSection from './components/HeroSection';
import { AppSection, CardsSection, FaqSection, IndexSection } from './components/SectionsA';
import { ContactSection, MediaSection, AboutSection, CommentsSection } from './components/SectionsB';
import { FeaturesSection, TopicsSection, UpdatesSection, RankingSection, CarouselSection } from './components/SectionsC';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <CardsSection />
        <FaqSection />
        <IndexSection />
        <ContactSection />
        <MediaSection />
        <AboutSection />
        <CommentsSection />
        <FeaturesSection />
        <TopicsSection />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}